import React, { useState, useEffect, Fragment } from "react";
import "./styles.css";
import { useHistory } from "react-router-dom";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import DialCodePicker, { CountryCodeData } from "components/dialCodePicker";
import {
  clearOTPState,
  clearResetPassword,
  resetPasswordRequest,
} from "common/features/auth/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { validateField } from "common/utils/field-validator";
import { useForm } from "react-hook-form";
import { SignUpForm } from "common/features/auth/AuthModels";
import { RootState } from "common/rootReducer";
import { getCountryRequest } from "common/features/auth/AuthActions";
import throttle from "lodash.throttle";
import OtpVerifyPopup from "../otpInputVerify";
import ResetPasswordPrompt from "../resetPasswordPrompt";

function ForgotInnerPopup(props: any) {
  //const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [userId, setUserId] = useState("");
  const [UserIdError, setUserIdError] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const countryCode = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );
  const resetPasswordOtpVerified = useSelector(
    (state: RootState) => state.auth.resetPasswordOtpVerified
  );
  useEffect(() => {
    dispatch(getCountryRequest());
  }, []);

  const [countryData, setCountryData] = useState<CountryCodeData>({
    code: "+1",
    flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
  });

  const resetPasswordMessage = useSelector(
    (state: RootState) => state.auth.resetPasswordMessage
  );
  const resetPasswordLoading = useSelector(
    (state: RootState) => state.auth.resetPasswordLoading
  );
  const resetPasswordInitiateSuccess = useSelector(
    (state: RootState) => state.auth.resetPasswordInitiateSuccess
  );

  useEffect(() => {
    dispatch(clearResetPassword());
    dispatch(clearOTPState());
  }, []);

  const onSubmit = () => {
    if (userId.length >= 10 && !resetPasswordLoading) {
      dispatch(
        resetPasswordRequest({
          mobilePhone: countryData.code + "-" + userId,
          sendOtp: 1,
          password: "",
        })
      );
    }
  };

  const throttledOnSubmit = throttle(onSubmit, 3000);

  useEffect(() => {
    if (resetPasswordInitiateSuccess && !resetPasswordLoading && userId!='') {
      // history.push({
      //   pathname: "/forgotInnerPopup/otp",
      //   state: {
      //     type: "reset password",
      //   },
      // });
      console.log('called otpViewLogin');
      
      props.setOtpView(true);
    }
  }, [resetPasswordLoading,userId]);

  const checkInput = (e: any) => {
    e.preventDefault();
    if (userId.length < 10) {
      setUserIdError(true);
    } else if (userId.length >= 10 && !resetPasswordLoading) {
      dispatch(
        resetPasswordRequest({
          mobilePhone: countryData.code + "-" + userId,
          sendOtp: 1,
          password: "",
        })
      );
    }
  };

  const {
    register,
    errors,
    handleSubmit,
    control,
    getValues,
    setValue,
    watch,
    formState,
  } = useForm<SignUpForm>({
    defaultValues: {
      userId: "",
    },
  });

  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);

  useEffect(() => {
    if (resetPasswordOtpVerified && resetPasswordInitiateSuccess) {
      props.setResetPasswordPopup(true);
      props.visible(true);
    }
  }, [resetPasswordOtpVerified]);

  return (
    <Fragment>
      <DialCodePicker
        showPicker={showDialCodePicker}
        setShowPicker={setShowDialCodePicker}
        setCountryData={setCountryData}
        inputValue={userId}
        setIsMobile={setIsMobile}
        onlyMobile={false}
      />
      {/* <ResetPasswordPrompt
        isOpen={resetPasswordPopup}
        visible={setResetPasswordOpen}
      /> */}

      {props.optView ? (
        <OtpVerifyPopup
          title={"Validate OTP"}
          type="password"
          setResetPasswordPopup={props.setResetPasswordPopup}
          visible={props.visible}
        />
      ) : (
        <div
          id="forgot-password-screen"
          className={showDialCodePicker ? "dim" : ""}
        >
          <span id="reset-info">
            Enter your registered phone number <br />
          </span>
          <br />
          <form autoComplete="off" onSubmit={handleSubmit(throttledOnSubmit)}>
            <div id="forgot-password-text-box-container">
              <span className="userTxt"> User ID</span>

              <div id="forgot-password-text-box">
                {true ? (
                  <Fragment>
                    <img
                      alt="flag"
                      src={countryData.flag}
                      height={"14px"}
                      width={"21px"}
                      className="flag"
                      onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                    />
                    &nbsp;
                    <span
                      className="countryCode"
                      onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                    >
                      {countryData.code}
                    </span>
                  </Fragment>
                ) : null}
                <input
                  className="placeholderTxt"
                  placeholder="Enter Mobile number"
                  onChange={(text) => {
                    setUserIdError(false)
                    setUserId(text.target.value);
                  }}
                  value={userId}
                  name="userId"
                  maxLength={10}
                  ref={register(
                    validateField("userId").isRequired().isValidMobileNumber()
                      .Rules
                  )}
                />
              </div>
              <span className="sign-up-form-error-msg">
                {UserIdError && <p>Mobile Number Required</p>}
                {errors.userId && errors.userId.type === "pattern" && (
                  <p>{errors.userId.message}</p>
                )}
                {resetPasswordMessage.length > 0 && (
                  <p>{resetPasswordMessage}</p>
                )}
              </span>
            </div>

            {/* {UserIdError == false ? ( */}
            <span id="button-container">
              <button
                type="submit"
                id="send-otp-button"
                onClick={(e) => {
                  checkInput(e);
                }}
              >
                {resetPasswordLoading ? "Validating" : "Send OTP"}
              </button>
            </span>
          </form>
        </div>
      )}
    </Fragment>
  );
}

export default ForgotInnerPopup;
